import * as z from "zod";
import { null as zNull } from "zod";

export const reorderParcels = {
  name: "reorderParcels" as const,
  input: z.object({
    parcels: z.array(
      z.object({
        /** Absent for parcels that have not been saved yet. */
        id: z.string().optional(),
        name: z.string(),
        position: z.number(),
      }),
    ),
  }),
  output: zNull(),
};
